import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import Footer from "./Footer";
import Footer1xbet from "./Footer1xbet";

function FooterIndex(props) {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? <Footer1xbet {...props} /> : <Footer {...props} />;
}

export default FooterIndex;
